// extracted by mini-css-extract-plugin
export default {"item":"Item_item__EsPFe","counter":"Item_counter__eHHfQ","icon":"Item_icon__jQS6M","title":"Item_title__U12pW","content":"Item_content__kzJ+f"};